<template>
    <section>
        <titlebar :title-stack="titleStack"></titlebar>
        <div class="tile is-ancestor">
            <article class="tile is-parent is-vertical is-9">
                <div class="tile is-child box">
                    <div class="columns">
                        <div class="column is-9">
                            <b-field label="Tipo de tarefa">
                                <b-input type="text" v-model="model.tipoNome" :disabled="readonly"></b-input>
                            </b-field>
                        </div>
                        <div class="column is-3">
                            <b-field label="Prioridade">
                                <b-input type="text" v-model="model.prioridade" :disabled="readonly"></b-input>
                            </b-field>
                        </div>
                    </div>
                    <div class="columns">
                        <div class="column is-9">
                            <b-field label="Assunto">
                                <b-input type="text" v-model="model.assunto" :disabled="readonly"></b-input>
                            </b-field>
                        </div>
                        <div class="column is-3">
                            <b-field label="Prazo" v-if="model.prazo">
                                <input type="text" :value="model.prazo | moment('DD/MM/YYYY HH:mm')" disabled />
                            </b-field>
                        </div>
                    </div>
                    <!--<div class="columns">
                        <div class="column content">
                            <b-field label="Descrição">
                                <div v-html="model.descricao"></div>
                            </b-field>
                        </div>
                    </div>-->
                    <div class="columns">
                        <div class="column is-3" v-if="readonly">
                            <b-field label="Cadastrado em">
                                <input type="text" class="input" :value="model.cadastradoEm | moment('DD/MM/YYYY HH:mm')" disabled />
                            </b-field>
                        </div>
                        <div class="column is-2">
                            <b-field label="Status">
                                <b-input type="text" v-model="model.status" :disabled="readonly"></b-input>
                            </b-field>
                        </div>
                        <div class="column is-3" v-if="model.agendamento">
                            <b-field label="Agendando para">
                                <input type="text" class="input" :value="model.agendamento | moment('DD/MM/YYYY HH:mm')" disabled />
                            </b-field>
                        </div>
                        <div class="column is-3" v-if="model.iniciadoEm">
                            <b-field label="Iniciado em">
                                <input type="text" class="input" :value="model.iniciadoEm | moment('DD/MM/YYYY HH:mm')" disabled />
                            </b-field>
                        </div>
                        <div class="column is-3" v-if="model.finalizadoEm">
                            <b-field label="Finalizado em">
                                <input type="text" class="input" :value="model.finalizadoEm | moment('DD/MM/YYYY HH:mm')" disabled />
                            </b-field>
                        </div>
                    </div>
                </div>
            </article>
            <article class="tile is-parent">
                <div class="tile is-child">
                    <article class="panel" v-if="model.atendimento">
                        <p class="panel-heading">
                            Atendimento de Origem
                        </p>
                        <router-link :to="{ name: 'atendimento', params: { id: model.atendimento.id }}" class="panel-block is-block">
                            <p>
                                {{model.atendimento.assunto}}
                            </p>
                            <div class="is-flex is-justified-between">
                                <small class="tag is-info">{{model.atendimento.id}}</small>
                                <span class="tag" :class="{'is-success': model.atendimento.status == 'Resolvido', 'is-warning': model.atendimento.status == 'AguardandoTarefa', 'is-danger': model.atendimento.status == 'Cancelado'}">{{ model.atendimento.status }}</span>
                            </div>
                        </router-link>
                    </article>
                </div>
            </article>
        </div>
    </section>
</template>

<script>
    import titlebar from '@/components/titlebar'

    export default {
        components: {
            titlebar
        },
        data() {
            return {
                model: {
                    atendimento: {}
                }
            }
        },
        computed: {
            titleStack() {
                return [
                    'Suporte',
                    'Tarefa',
                    this.$route.params.id
                ]
            },
            readonly() {
                return (this.$route.params.id)
            }
        },
        created() {
            if (this.$route.params.id) {
                this.$http.get(`/api/portal/tarefa?id=${this.$route.params.id}`)
                    .then(response => {
                        this.model = response.data
                    })
            }
        }
    }

</script>
